export default function accordion() {
    Alpine.data('accordion',       () => ({
        active:0,
        toggle(index){
            if(this.active === index){
                this.active = null
            }else{
                this.active = index
            }
        }
    }))
}